const cohortByCourse = (
  state = {
    isFetching: false,
    receivedAt: null,
    data: [],
  },
  action,
) => {
  switch (action.type) {
    case 'REQUEST_COHORTS':
      return {
        ...state,
        isFetching: true,
      }
    case 'RECEIVE_COHORTS':
      return {
        ...state,
        isFetching: false,
        data: action.cohorts,
        receivedAt: Date.now(),
      }
    default:
      return state
  }
}

const cohorts = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseId]: cohortByCourse(state[currentCourse.courseId], action),
          }
        }, {})
      }
    case 'REQUEST_COHORTS':
    case 'RECEIVE_COHORTS':
      return {
        ...state,
        [action.courseId]: cohortByCourse(state[action.courseId], action)
      }
    default:
      return state
  }
}

export default cohorts
